const __WEBPACK_NAMESPACE_OBJECT__ = require("next/dist/server/lib/trace/tracer");